import type {
	CustomItem,
	DropHybridFormatsType,
	Item,
} from '#lib/features/drop-page/constants/types.js';

export const isDropHybridFormats = (
	item: Item | CustomItem
): item is DropHybridFormatsType => {
	return !!(item && item.__typename === 'Drop_Hybrid_Formats');
};
